/* 
  微信分享
  @data: {appId: String, 
    timestamp: String,
    nonceStr: String,
    signature: String,},通过config接口注入权限验证配置, getWXJSConfig接口
  @shareInfo: {
    title: String,
    desc: String,
    link: string,
    imgUrl: string,
  }, 分享信息
*/
export function wechatShare(data, shareInfo) {
  wx.config({
    // debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    appId: data.appId, // 必填，公众号的唯一标识
    timestamp: data.timestamp, // 必填，生成签名的时间戳
    nonceStr: data.nonceStr, // 必填，生成签名的随机串
    signature: data.signature,// 必填，签名
    jsApiList: ["onMenuShareAppMessage", "onMenuShareTimeline", "onMenuShareQQ", "onMenuShareQZone"] // 必填，需要使用的JS接口列表
  });

  wx.ready(function () {
    /* 分享给朋友 */
    wx.onMenuShareAppMessage({
      title: shareInfo.title, // 分享标题
      desc: shareInfo.desc, // 分享描述
      link: shareInfo.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: shareInfo.imgUrl, // 分享图标
      type: '', // 分享类型,music、video或link，不填默认为link
      dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
      success: function () {
      }
    });

    /* 分享到朋友圈*/
    wx.onMenuShareTimeline({
      title: shareInfo.title, // 分享标题
      link: shareInfo.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: shareInfo.imgUrl, // 分享图标
      success: function () {
        // 用户点击了分享后执行的回调函数
      },
    });

    /* 分享到QQ*/
    wx.onMenuShareQQ({
      title: shareInfo.title, // 分享标题
      link: shareInfo.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      desc: shareInfo.desc, // 分享描述
      imgUrl: shareInfo.imgUrl, // 分享图标
      success: function () {
        // 用户点击了分享后执行的回调函数
      },
    });

    /* 分享到QQ空间*/
    wx.onMenuShareQZone({
      title: shareInfo.title, // 分享标题
      link: shareInfo.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      desc: shareInfo.desc, // 分享描述
      imgUrl: shareInfo.imgUrl, // 分享图标
      success: function () {
        // 用户点击了分享后执行的回调函数
      },
    });
  });
}

// 消费者app分享
export function appShare(shareInfo) {
  window.appShareCallback = () => { };
  let jsonStr = {
    callInfoList: [{
      actionType: 2000,
      funcName: 'appShareCallback',
      actionParam: {
        'title': shareInfo.title,
        'icon': shareInfo.imgUrl,
        'desc': shareInfo.desc,
        'link': shareInfo.link,
        'smsDesc': shareInfo.desc,
      }
    }]
  };

  jsonStr = JSON.stringify(jsonStr);
  let u = navigator.userAgent;
  if (u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {   // ios
    window.location.href = 'npc4fc://?jsonStr=' + jsonStr;
  } else if (window.npc4fc) {  // android
    window.npc4fc.callAction(jsonStr);
  }
}


// 支付宝分享
export function alipayShare(shareInfo) {
  Ali.share({
    //渠道名称。支持以下几种：Weibo/LaiwangContacts/LaiwangTimeline/Weixin/WeixinTimeLine/SMS/CopyLink
    'channels': [
      {
        name: 'ALPContact',   //支付宝联系人,9.0版本
        param: {   //请注意，支付宝联系人仅支持一下参数
          contentType: 'url',    //必选参数,目前支持支持"text","image","url"格式
          content: shareInfo.desc,    //必选参数,分享描述
          iconUrl: shareInfo.imgUrl,   //必选参数,缩略图url，发送前预览使用,
          imageUrl: shareInfo.imgUrl, //图片url
          url: shareInfo.link,   //必选参数，卡片跳转连接
          title: shareInfo.title,    //必选参数,分享标题
          memo: ""   //透传参数,分享成功后，在联系人界面的通知提示。
        },

      },
      {
        name: 'ALPTimeLine', //支付宝生活圈
        param: {
          contentType: 'url',    //必选参数,目前只支持"url"格式
          title: shareInfo.title,   //标题
          url: shareInfo.link,  //url
          iconUrl: shareInfo.imgUrl
        },

      },
      {
        name: 'CopyLink', //复制链接
        param: {
          url: shareInfo.link
        }
      }]
  }, function (result) {
    // alert(result.errorCode);
  });
}
